import { Canceler } from "axios";
import { EntityApi } from "../../services/ApiPlatform";
import { PrimitiveObject } from "../../services/ApiPlatform/types";
import { FinalResponse, ListResponse } from "../../services/ApiPlatform/models";

export abstract class InternshipApi extends EntityApi {
    protected static GET_COLLECTION = "/api/internships";

    protected static POST_COLLECTION = "/api/internships";

    protected static GET_ITEM = "/api/internships/{id}";

    protected static PUT_ITEM = "/api/internships/{id}";

    protected static PATCH_ITEM = "/api/internships/{id}";

    protected static DELETE_ITEM = "/api/internships/{id}";

    protected static GET_COLLECTION_MY_INTERNSHIPS = "/api/internships/my";

    protected static GET_COLLECTION_MY_INTERNSHIPS_FIND =
        "/api/internships/my-find";

    protected static GET_COLLECTION_FIND_FOR_MAP =
        "/api/internships/find-for-map";

    public static async getCollectionMyInternships<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_MY_INTERNSHIPS,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }

    public static async getCollectionMyInternshipsFind<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_MY_INTERNSHIPS_FIND,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }

    public static async getCollectionFindForMap<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_FIND_FOR_MAP,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }
}
